module.exports = __webpack_public_path__ + "img/0.e1d01841.png";